<template>
  <div>
    <v-carousel
            height="auto"
            cycle
            show-arrows-on-hover
            hide-delimiter
            hide-delimiter-background
            v-model="currentImg"
    >
      <v-carousel-item
              v-for="(slide, i) in images"
              :key="i"
              aspect-ratio="2"
      >
        <v-row class="fill-height" align="center" justify="center">
          <v-img
                  @click="clickSeeBigger"
                  :src="slide.slide_image"
                  aspect-ratio="2"
          ></v-img>
        </v-row>
      </v-carousel-item>
    </v-carousel>
    <v-dialog fullscreen overlay-opacity=".8" width="100%" v-model="seeBigger">
<!--      <v-btn fab small absolute right class="ma-3" style="right: 25px;" color="#2e8037" @click="seeBigger = false">-->
<!--        <v-icon color="#fff">mdi-close</v-icon>-->
<!--      </v-btn>-->
      <div class="fill-height d-flex align-center" style="background: white">
        <v-carousel
                height="auto"
                show-arrows-on-hover
                hide-delimiter
                hide-delimiter-background
                v-model="currentImg"
        >
          <v-snackbar v-model="snackbar" :timeout="3000" transition="scale-transition">
            <span style="font-family: Poppins, Kanit;">{{ $t('carousel.click-any-close') }}</span>
            <template v-slot:action="{ attrs }">
              <v-btn
                      color="#2e8037"
                      icon
                      v-bind="attrs"
                      @click="snackbar = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <v-carousel-item
                  v-for="(slide, i) in images"
                  :key="i"
                  aspect-ratio="2"
          >
            <v-row class="fill-height" align="center" justify="center">
              <img
                      @click="seeBigger = false"
                      class="image-full"
                      :src="slide.slide_image">
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    images : {
      type: Array,
    }
  },
  data: () => ({
    snackbar: false,
    seeBigger: false,
    currentImg: 1
  }),
  methods: {
    clickSeeBigger() {
      this.seeBigger = !this.seeBigger;
      if (this.seeBigger) {
        this.snackbar = true;
      }
    }
  }
};
</script>

<style>
  .image-full {
    display: block;
    max-height: 100vh;
    width: 100%;
    height: auto;
  }
</style>
